export default (value: Date) => {
    if (!value) {
        return "Unknown";
    }
    const date = new Date(value)
    return date.toLocaleDateString(['en-GB'], {month: 'long', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
}
